// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"index_breadcrumbs__uLkl2","wrapper":"index_wrapper__iEonS","searchWrapper":"index_searchWrapper__PYMKY"};